import { getAttribution, syncAttributionCookie } from '@markku/attribution'
import type { AttributionPayload } from '@markku/types'

export type { AttributionPayload }

// The mk_attr cookie is the durable cross-session store; sessionStorage is a
// fallback for embedded iframe contexts where the cookie is unavailable at
// OTP-register time.
const ATTRIBUTION_KEY = 'mk_attr'

function storeAttribution(payload: AttributionPayload): void {
  try {
    sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(payload))
  } catch {
    // sessionStorage disabled — cookie still persists attribution
  }
}

/**
 * Returns the full first/last-touch payload from the mk_attr cookie (or the
 * sessionStorage fallback). Consumers choose which touch they want —
 * endpoints that stamp the user at creation pick firstTouch, endpoints that
 * record a booking/lead event pick lastTouch. See docs/attribution-semantics.md.
 */
export function getAttributionPayload(): AttributionPayload | undefined {
  const fromCookie = getAttribution()
  if (fromCookie) return fromCookie

  try {
    const stored = sessionStorage.getItem(ATTRIBUTION_KEY)
    if (stored) return JSON.parse(stored) as AttributionPayload
  } catch {
    return undefined
  }
  return undefined
}

export function initAcquisitionTracking(): void {
  const payload = syncAttributionCookie()
  storeAttribution(payload)
}
